import { createElement, type ComponentProps } from "react";
import { styled, Typography } from "@mui/material";
import { styledConstants } from "./styledConstants";

export const StyledErrorDiv = styled("div")({
  ...styledConstants.errorLabel,
  position: "absolute",
  left: 0,
  top: "calc(100% + 0.25rem)",
  width: "100%",
  marginTop: 0,
});

export const StyledInformationDiv = styled("div")(styledConstants.informationLabel);

export const MobileHeader2 = (props: ComponentProps<typeof Typography>) => {
    return createElement(Typography, { ...props, sx: { fontSize: '1rem', fontWeight: 500 } });
};

export const MobileHeader1 = (props: ComponentProps<typeof Typography>) => {
    return createElement(Typography, { ...props, sx: { fontSize: '1.4rem', fontWeight: 600 } });
};

export const UserEditStyledTextTypography = styled(Typography)(() => ({
  fontSize: "0.85rem",
}));